export const getMessages = (state) => state.notificationHandler.messages
